export default "__VITE_ASSET__CU22VXJD__"